import "../src/utils/fetchInterceptors";
import "./App.css";
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Login from "./components/common/login";
import Profile from "./components/common/profile";
import Institution from "./components/admin/institution";
import InstitutionInfo from "./components/admin/institutionInfo";
import ProtectedRoute from "./components/common/ProtectedRoute";
import DashboardLayout from "./components/layout/DashboardLayout";
import DashboardPage from "./components/common/DashboardPage";
import InstitutionDashboardPage from "./components/institution/InstitutionDashboardPage";
import InstitutionDashboardHome from "./components/institution/InstitutionDashboardHome";
import CoursesHome from "./components/admin/courses/coursesHome";
import InstitutionCourseInfo from "./components/admin/institutionCourseInfo";
import InstitutionCourseBatchInfo from "./components/admin/institutionCourseBatchInfo";
import CourseDetails from "./components/admin/courses/CourseDetails";
import InitialTestCourses from "./components/admin/initialTest/InitialTestCourses";
import InitialTestCourseTests from "./components/admin/initialTest/InitialTestCourseTests";
import CreateInitialTestPage from "./components/admin/initialTest/CreateInitialTestPage";
import SubjectDetails from "./components/admin/courses/SubjectDetails";
import TopicDetails from "./components/admin/courses/TopicDetails";
import SubTopicDetails from "./components/admin/courses/subTopicDetails";
import QuestionBankCourses from "./components/admin/questionBank/QuestionBankCourses";
import QuestionBankSubjects from "./components/admin/questionBank/QuestionBankSubjects";
import QuestionBankTopics from "./components/admin/questionBank/QuestionBankTopics";
import QuestionBankSubtopics from "./components/admin/questionBank/QuestionBankSubtopics";
import QuestionBankSubtopicFiles from "./components/admin/questionBank/QuestionBankSubtopicFiles";
import QuestionBankFolderPage from "./components/admin/questionBank/QuestionBankFolderPage";
import MaterialsCourses from "./components/admin/materials/MaterialsCourses";
import MaterialsSubjects from "./components/admin/materials/MaterialsSubjects";
import MaterialsTopics from "./components/admin/materials/MaterialsTopics";
import MaterialsSubtopics from "./components/admin/materials/MaterialsSubtopics";
import MaterialsSubtopicFiles from "./components/admin/materials/MaterialsSubtopicFiles";
import MaterialsFolderPage from "./components/admin/materials/MaterialsFolderPage";
import InstitutionTeacher from "./components/institution/institutionTeacher";
import InstitutionStudent from "./components/institution/institutionStudent";
import BatchInstitution from "./components/institution/institutionBatch";
import InstitutionBatchCourseList from "./components/institution/institutionBatchCourseList";
import InstitutionBatchDetails from "./components/institution/institutionBatchDetails";
import Preference from "./components/admin/preference";
import IqTest from "./components/admin/iqTest";
import ModelsPage from "./components/admin/models/ModelsPage";
import PromptsPage from "./components/admin/prompts/PromptsPage";
import Gamification from "./components/admin/gamification/gamificationPage";
import HomeworkCourses from "./components/teacher/homework/HomeworkCourses";
import HomeworkBatches from "./components/teacher/homework/HomeworkBatches";
import HomeworkSubjects from "./components/teacher/homework/HomeworkSubjects";
import HomeworkTopics from "./components/teacher/homework/HomeworkTopics";
import HomeworkSubtopics from "./components/teacher/homework/HomeworkSubtopics";
import HomeworkSubtopicFiles from "./components/teacher/homework/HomeworkSubtopicFiles";
import HomeworkDetail from "./components/teacher/homework/HomeworkDetail";
import AssignHomework from "./components/teacher/homework/AssignHomework";
import TeacherDashboardPage from "./components/teacher/TeacherDashboardPage";
import OverallTestViewer from "./components/admin/overall/OverallTestViewer";
import OverallTestList from "./components/admin/overall/OverallTestList";
import OverallCourses from "./components/admin/overall/OverallCourses";
import OverallMaterialsPage from "./components/admin/overallMaterials/OverallMaterialsPage";
import BlogPage from "./components/admin/blog/BlogPage";
import BlogViewer from "./components/admin/blog/BlogViewer";
import VideosPage from "./components/admin/videos/VideosPage";
import OverallMaterialsCourses from "./components/admin/overallMaterials/OverallMaterialsCourses";
import BlogCourses from "./components/admin/blog/BlogCourses";
import EvalHome from "./components/admin/eval/EvalHome";
import EvalDetails from "./components/admin/eval/EvalDetails";
import AdminDashboardCumulativePage from "./components/admin/dashboard/AdminDashboardCumulativePage";
import ImageUploadFolderPage from "./components/admin/imageUpload/ImageUploadFolderPage";
import ImageFolderDetailsPage from "./components/admin/imageUpload/ImageFolderDetailsPage";
import ResetPassword from "./components/common/ResetPassword";

function App() {
  return (
    <Routes>
      <Route path="/admin/login" element={<Login />} />
      <Route path="" element={<Login />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route
        path="/admin"
        element={
          <ProtectedRoute>
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        <Route path="dashboard" element={<AdminDashboardCumulativePage />} />
        <Route path="reports" element={<DashboardPage />} />
        <Route
          path="reports/institution/:institutionId"
          element={<DashboardPage />}
        />
        <Route
          path="reports/institution/:institutionId/course/:courseKey"
          element={<DashboardPage />}
        />
        <Route
          path="reports/institution/:institutionId/course/:courseKey/batches"
          element={<DashboardPage />}
        />
        <Route
          path="reports/institution/:institutionId/course/:courseKey/batch/:batchId"
          element={<DashboardPage />}
        />
        <Route
          path="reports/institution/:institutionId/course/:courseKey/batch/:batchId/reports"
          element={<DashboardPage />}
        />
        <Route
          path="reports/institution/:institutionId/course/:courseKey/batch/:batchId/student/:studentId"
          element={<DashboardPage />}
        />
        <Route
          path="reports/institution/:institutionId/course/:courseKey/batch/:batchId/teacher/:teacherId"
          element={<DashboardPage />}
        />
        <Route path="profile" element={<Profile />} />
        <Route path="courses" element={<CoursesHome />} />
        <Route path="eval" element={<EvalHome />} />
        <Route path="materials" element={<MaterialsCourses />} />
        <Route
          path="materials/course/:courseKey"
          element={<MaterialsSubjects />}
        />
        <Route
          path="materials/course/:courseKey/subject/:subjectKey"
          element={<MaterialsTopics />}
        />
        <Route
          path="materials/course/:courseKey/subject/:subjectKey/topic/:topicKey"
          element={<MaterialsSubtopics />}
        />
        <Route
          path="materials/course/:courseKey/subject/:subjectKey/topic/:topicKey/subtopic/:subtopicKey"
          element={<MaterialsSubtopicFiles />}
        />
        <Route
          path="materials/folder/:folderId"
          element={<MaterialsFolderPage />}
        />

        <Route path="question-bank" element={<QuestionBankCourses />} />
        <Route
          path="question-bank/course/:courseKey"
          element={<QuestionBankSubjects />}
        />
        <Route
          path="question-bank/course/:courseKey/subject/:subjectKey"
          element={<QuestionBankTopics />}
        />
        <Route
          path="question-bank/course/:courseKey/subject/:subjectKey/topic/:topicKey"
          element={<QuestionBankSubtopics />}
        />
        <Route
          path="question-bank/course/:courseKey/subject/:subjectKey/topic/:topicKey/subtopic/:subtopicKey"
          element={<QuestionBankSubtopicFiles />}
        />
        <Route
          path="question-bank/folder/:folderId"
          element={<QuestionBankFolderPage />}
        />
        <Route path="initial-test" element={<InitialTestCourses />} />
        <Route
          path="initial-test/course/:key"
          element={<InitialTestCourseTests />}
        />
        <Route
          path="initial-test/course/:key/create"
          element={<CreateInitialTestPage />}
        />
        <Route path="eval/:key" element={<EvalDetails />} />
        <Route path="course/:key" element={<CourseDetails />} />
        <Route
          path="course/:key/subject/:subkey"
          element={<SubjectDetails />}
        />
        <Route path="eval/:key/subject/:subkey" element={<SubjectDetails />} />
        <Route
          path="course/:key/subject/:subkey/topic/:topicKey"
          element={<TopicDetails />}
        />
        <Route
          path="eval/:key/subject/:subkey/topic/:topicKey"
          element={<TopicDetails />}
        />
        <Route
          path="course/:key/subject/:subkey/topic/:topicKey/subTopic/:subTopicKey"
          element={<SubTopicDetails />}
        />
        <Route
          path="eval/:key/subject/:subkey/topic/:topicKey/subTopic/:subTopicKey"
          element={<SubTopicDetails />}
        />
        <Route path="institution" element={<Institution />} />
        <Route path="institution/info" element={<InstitutionInfo />} />
        <Route
          path="institution/course/info"
          element={<InstitutionCourseInfo />}
        />
        <Route
          path="institution/course/batch"
          element={<InstitutionCourseBatchInfo />}
        />
        <Route path="preference" element={<Preference />} />
        <Route path="iq_test" element={<IqTest />} />
        <Route path="models" element={<ModelsPage />} />
        <Route path="ai-configuration" element={<PromptsPage />} />
        <Route path="gamification" element={<Gamification />} />
        <Route path="image-upload" element={<ImageUploadFolderPage />} />
        <Route path="image-folders" element={<ImageUploadFolderPage />} />
        <Route
          path="image-folders/:folderId"
          element={<ImageFolderDetailsPage />}
        />
      </Route>
      <Route
        path="/institution"
        element={
          <ProtectedRoute>
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        <Route path="dashboard" element={<InstitutionDashboardHome />} />
        <Route path="reports" element={<InstitutionDashboardPage />} />
        <Route
          path="reports/course/:courseKey"
          element={<InstitutionDashboardPage />}
        />
        <Route
          path="reports/course/:courseKey/batches"
          element={<InstitutionDashboardPage />}
        />
        <Route
          path="reports/course/:courseKey/batch/:batchId"
          element={<InstitutionDashboardPage />}
        />
        <Route
          path="reports/course/:courseKey/batch/:batchId/reports"
          element={<InstitutionDashboardPage />}
        />
        <Route
          path="reports/course/:courseKey/batch/:batchId/teacher/:teacherId"
          element={<InstitutionDashboardPage />}
        />
        <Route
          path="reports/course/:courseKey/batch/:batchId/student/:studentId"
          element={<InstitutionDashboardPage />}
        />
        <Route path="profile" element={<Profile />} />
        <Route path="courses" element={<CoursesHome />} />
        <Route path="course/:key" element={<CourseDetails />} />
        <Route path="batches" element={<InstitutionBatchCourseList />} />
        <Route path="batches/info" element={<BatchInstitution />} />
        <Route path="batches/details" element={<InstitutionBatchDetails />} />
        <Route
          path="course/:key/subject/:subkey"
          element={<SubjectDetails />}
        />
        <Route
          path="course/:key/subject/:subkey/topic/:topicKey"
          element={<TopicDetails />}
        />
        <Route
          path="course/:key/subject/:subkey/topic/:topicKey/subTopic/:subTopicKey"
          element={<SubTopicDetails />}
        />
        <Route path="info" element={<InstitutionInfo />} />
        <Route path="course/info" element={<InstitutionCourseInfo />} />
        <Route path="course/batch" element={<InstitutionCourseBatchInfo />} />
        <Route path="teachers" element={<InstitutionTeacher />} />
        <Route path="students" element={<InstitutionStudent />} />
        <Route path="materials" element={<MaterialsCourses />} />
        <Route
          path="materials/course/:courseKey"
          element={<MaterialsSubjects />}
        />
        <Route
          path="materials/course/:courseKey/subject/:subjectKey"
          element={<MaterialsTopics />}
        />
        <Route
          path="materials/course/:courseKey/subject/:subjectKey/topic/:topicKey"
          element={<MaterialsSubtopics />}
        />
        <Route
          path="materials/course/:courseKey/subject/:subjectKey/topic/:topicKey/subtopic/:subtopicKey"
          element={<MaterialsSubtopicFiles />}
        />
        <Route
          path="materials/folder/:folderId"
          element={<MaterialsFolderPage />}
        />

        <Route path="question_banks" element={<QuestionBankCourses />} />
        <Route
          path="question_banks/course/:courseKey"
          element={<QuestionBankSubjects />}
        />
        <Route
          path="question_banks/course/:courseKey/subject/:subjectKey"
          element={<QuestionBankTopics />}
        />
        <Route
          path="question_banks/course/:courseKey/subject/:subjectKey/topic/:topicKey"
          element={<QuestionBankSubtopics />}
        />
        <Route
          path="question_banks/course/:courseKey/subject/:subjectKey/topic/:topicKey/subtopic/:subtopicKey"
          element={<QuestionBankSubtopicFiles />}
        />
        <Route
          path="question_banks/folder/:folderId"
          element={<QuestionBankFolderPage />}
        />
      </Route>
      <Route
        path="/teacher"
        element={
          <ProtectedRoute>
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="dashboard" replace />} />
        <Route path="dashboard" element={<TeacherDashboardPage />} />
        <Route path="profile" element={<Profile />} />
        <Route path="courses" element={<CoursesHome />} />
        <Route path="course-content" element={<CoursesHome />} />
        <Route path="course/:key" element={<CourseDetails />} />
        <Route
          path="course/:key/subject/:subkey"
          element={<SubjectDetails />}
        />
        <Route
          path="course/:key/subject/:subkey/topic/:topicKey"
          element={<TopicDetails />}
        />
        <Route
          path="course/:key/subject/:subkey/topic/:topicKey/subTopic/:subTopicKey"
          element={<SubTopicDetails />}
        />
        <Route path="batches" element={<InstitutionBatchCourseList />} />
        <Route path="batches/info" element={<BatchInstitution />} />
        <Route path="batches/details" element={<InstitutionBatchDetails />} />
        <Route path="students" element={<InstitutionStudent />} />
        <Route path="materials" element={<MaterialsCourses />} />
        <Route
          path="materials/course/:courseKey"
          element={<MaterialsSubjects />}
        />
        <Route
          path="materials/course/:courseKey/subject/:subjectKey"
          element={<MaterialsTopics />}
        />
        <Route
          path="materials/course/:courseKey/subject/:subjectKey/topic/:topicKey"
          element={<MaterialsSubtopics />}
        />
        <Route
          path="materials/course/:courseKey/subject/:subjectKey/topic/:topicKey/subtopic/:subtopicKey"
          element={<MaterialsSubtopicFiles />}
        />
        <Route
          path="materials/folder/:folderId"
          element={<MaterialsFolderPage />}
        />
        <Route path="question_banks" element={<QuestionBankCourses />} />
        <Route
          path="question_banks/course/:courseKey"
          element={<QuestionBankSubjects />}
        />
        <Route
          path="question_banks/course/:courseKey/subject/:subjectKey"
          element={<QuestionBankTopics />}
        />
        <Route
          path="question_banks/course/:courseKey/subject/:subjectKey/topic/:topicKey"
          element={<QuestionBankSubtopics />}
        />
        <Route
          path="question_banks/course/:courseKey/subject/:subjectKey/topic/:topicKey/subtopic/:subtopicKey"
          element={<QuestionBankSubtopicFiles />}
        />
        <Route
          path="question_banks/folder/:folderId"
          element={<QuestionBankFolderPage />}
        />
        <Route path="overall" element={<OverallCourses />} />
        <Route path="overall/tests" element={<OverallTestList />} />
        <Route path="overall/view" element={<OverallTestViewer />} />
        <Route path="guides-materials" element={<OverallMaterialsCourses />} />
        <Route
          path="guides-materials/list"
          element={<OverallMaterialsPage />}
        />
        <Route path="blog" element={<BlogCourses />} />
        <Route path="blog/list" element={<BlogPage />} />
        <Route path="blog/view" element={<BlogViewer />} />
        <Route path="videos" element={<VideosPage />} />
        <Route path="homework" element={<HomeworkCourses />} />
        <Route path="homework/batches" element={<HomeworkBatches />} />
        <Route path="homework/course/:key" element={<HomeworkSubjects />} />
        <Route
          path="homework/course/:key/subject/:subkey"
          element={<HomeworkTopics />}
        />
        <Route
          path="homework/course/:key/subject/:subkey/topic/:topicKey"
          element={<HomeworkSubtopics />}
        />
        <Route
          path="homework/course/:key/subject/:subkey/topic/:topicKey/subtopic/:subtopicKey"
          element={<HomeworkSubtopicFiles />}
        />
        <Route path="homework/detail" element={<HomeworkDetail />} />
        <Route path="course/homework/detail" element={<HomeworkDetail />} />
        <Route path="subject/homework/detail" element={<HomeworkDetail />} />
        <Route path="topic/homework/detail" element={<HomeworkDetail />} />
        <Route path="subtopic/homework/detail" element={<HomeworkDetail />} />
        <Route path="homework/completed" element={<HomeworkDetail />} />
        <Route path="course/homework/completed" element={<HomeworkDetail />} />
        <Route path="subject/homework/completed" element={<HomeworkDetail />} />
        <Route path="topic/homework/completed" element={<HomeworkDetail />} />
        <Route
          path="subtopic/homework/completed"
          element={<HomeworkDetail />}
        />
        <Route path="homework/assign" element={<AssignHomework />} />
        <Route
          path="homework/course/:key/assign"
          element={<AssignHomework />}
        />
        <Route
          path="homework/course/:key/subject/:subkey/assign"
          element={<AssignHomework />}
        />
        <Route
          path="homework/course/:key/subject/:subkey/topic/:topicKey/assign"
          element={<AssignHomework />}
        />
        <Route
          path="homework/course/:key/subject/:subkey/topic/:topicKey/subtopic/:subtopicKey/assign"
          element={<AssignHomework />}
        />
      </Route>
    </Routes>
  );
}

export default App;
